import type { BetSlipState } from '../types';
import { getSelectionsFromSingleOpportunities } from '../utils/getSelectionsFromSingleOpportunities';

import priceChangesAccepted from './priceChangesAccepted';

const selectionsReused = (state: BetSlipState): BetSlipState => ({
  ...state,
  ...priceChangesAccepted(state, state.submittedOpportunities),
  selections: getSelectionsFromSingleOpportunities(state.submittedOpportunities.SINGLE)
});

export default selectionsReused;
